import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const TitleChanger = () => {
  const location = useLocation();

  let url = location.pathname.replaceAll('/', ' ');
  url = url.replaceAll('-', ' ');

  const title = url.split(' ');

  for (let i = 1; i < title.length; i++) {
    title[i] = title[i][0] ? title[i][0].toUpperCase() + title[i].substr(1) : 'Portfolio Manager';
  }
  title.shift();
  const pageName = title[0];
  title.shift();

  return (
    <>
      <Helmet>
        <title>{pageName + ' - ' + title.join(' ')}</title>
        <title>{title.length === 0 ? `${pageName}` : pageName + ' - ' + title.join(' ')}</title>
      </Helmet>
    </>
  );
};

export default TitleChanger;
